import script from "./AccountIsFrozen.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountIsFrozen.vue?vue&type=script&setup=true&lang=js"

import "./AccountIsFrozen.vue?vue&type=style&index=0&id=4f35f780&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f35f780"]])

export default __exports__